export var Book;
(function (Book) {
    Book["Core"] = "Shadow of the Demon Lord Core";
    Book["DemonLordsCompanion"] = "Demon Lord's Companion";
    Book["OccultPhilosophy"] = "Occult Philosophy";
    Book["TerribleBeauty"] = "Terrible Beauty";
    Book["ExquisiteAgony"] = "Exquisite Agony";
    Book["HungerInTheVoid"] = "The Hunger in the Void";
    Book["FreeportCompanion"] = "Freeport Companion";
    Book["BlackSunDawn"] = "Black Sun Dawn";
    Book["BeyondTheWorldsEdge"] = "Beyond the World's Edge";
    Book["TombsOfDesolation"] = "Tombs of the Desolation";
    Book["MenOfGog"] = "Men of Gog";
    Book["CurseOfTheSpiderWood"] = "Curse of the Spider Wood";
})(Book || (Book = {}));
export var Danger;
(function (Danger) {
    Danger["Easy"] = "Easy";
    Danger["Average"] = "Average";
    Danger["Challenging"] = "Challenging";
    Danger["Hard"] = "Hard";
})(Danger || (Danger = {}));
export var GroupLevel;
(function (GroupLevel) {
    GroupLevel["Starting"] = "Starting";
    GroupLevel["Novice"] = "Novice";
    GroupLevel["Expert"] = "Expert";
    GroupLevel["Master"] = "Master";
})(GroupLevel || (GroupLevel = {}));
export const DEFAULT_ENCOUNTER_PARAMS = { playerCount: 3, groupLevel: GroupLevel.Starting, danger: Danger.Easy };
